// Crockford base32 alphabet (no I, L, O, U to avoid confusion)
const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

/**
 * Generates a unique FixID serial number in the format: FXD-YYYY-XXXXXX
 * Example: FXD-2026-7H3K9P
 */
export function generateFixidSerial(): string {
  const year = new Date().getFullYear();
  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  const code = Array.from(bytes)
    .map((b) => ALPHABET[b % ALPHABET.length])
    .join("");
  return `FXD-${year}-${code}`;
}
